/** @format */
import React, { ReactNode } from 'react';

import CanonSVG from '@toucan/images/brands/canon.svg';
import DJISVG from '@toucan/images/brands/dji.svg';
import FujiSVG from '@toucan/images/brands/fuji.svg';
import HasselbladSVG from '@toucan/images/brands/hasselblad.svg';
import LeicaSVG from '@toucan/images/brands/leica.svg';
import NikonSVG from '@toucan/images/brands/nikon.svg';
import OlympusSVG from '@toucan/images/brands/olympus.svg';
import PanasonicSVG from '@toucan/images/brands/panasonic.svg';
import RedDigiSVG from '@toucan/images/brands/red.svg';
import SigmaSVG from '@toucan/images/brands/sigma.svg';
import SonySVG from '@toucan/images/brands/sony.svg';

export type PopularBrand = {
    name: string;
    id: number;
    logo: ReactNode;
};

export const popularBrands: PopularBrand[] = [
    {
        name: 'Canon',
        id: 6096,
        logo: <CanonSVG />,
    },
    {
        name: 'Nikon',
        id: 6097,
        logo: <NikonSVG />,
    },
    {
        name: 'Sony',
        id: 6100,
        logo: <SonySVG />,
    },
    {
        name: 'Fujifilm',
        id: 6101,
        logo: <FujiSVG />,
    },
    {
        name: 'Panasonic',
        id: 6098,
        logo: <PanasonicSVG />,
    },
    {
        name: 'Olympus',
        id: 6099,
        logo: <OlympusSVG />,
    },
    {
        name: 'Sigma',
        id: 6112,
        logo: <SigmaSVG />,
    },
    {
        name: 'Leica',
        id: 6102,
        logo: <LeicaSVG />,
    },
    {
        name: 'Hasselblad',
        id: 6103,
        logo: <HasselbladSVG />,
    },
    {
        name: 'DJI',
        id: 6211,
        logo: <DJISVG />,
    },
    {
        name: 'RED Digital Cinema',
        id: 6106,
        logo: <RedDigiSVG />,
    },
];
